export default __webpack_public_path__ + "static/media/Pointing.284be576.gif";